import { findRoomByStandName } from '@bottlebooks/gatsby-plugin-california-pdf/src/templates/VieVinum/helpers/rooms';
import { setSaturation, transparentize } from 'polished';

export default function getExhibitorRoomColors(exhibitor) {
  return getRoomColors(findRoomByStandName(exhibitor?.stand?.name));
}

export function getRoomColors(room) {
  if (!room) return {};
  const primary = room?.colors?.primary || '#778';
  const onPrimary = room?.colors?.onPrimary || 'white';
  const shadow = transparentize(0.8, setSaturation(0.2, primary));
  return {
    primary,
    primaries: {
      10: transparentize(0.9, setSaturation(0.15, primary)),
      20: transparentize(0.8, setSaturation(0.2, primary)),
      30: transparentize(0.7, setSaturation(0.3, primary)),
      40: transparentize(0.6, setSaturation(0.4, primary)),
      50: transparentize(0.5, setSaturation(0.5, primary)),
    },
    onPrimary,
    shadow,
  };
}
